var themeUtils = {
    appendToQuerystring: function (url, params) {
      const urlObj = (url.indexOf('http') == 0) ? new URL(url) : new URL(url, window.location.origin);
      const searchParams = urlObj.searchParams;    
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          searchParams.append(key, params[key]);
        }
      }    
      urlObj.search = searchParams.toString();
      return urlObj.toString();
    },
    
    parseQuerystringFromUrl: function (url) {
      const urlObj = (url.indexOf('http') == 0) ? new URL(url) : new URL(url, window.location.origin);
      const searchParams = urlObj.searchParams;
      const paramsObject = Object.fromEntries(searchParams.entries());
      return paramsObject;
    },

    removeQueryString: function (url) {
      const idx = url.indexOf('?');
      if (idx !== -1) {
        return url.substring(0, idx);
      }
      return url;
    }
};

function handleBrandsMenu() {
  var brandsMenu = $('.header__primary-nav-item[data-title="Brands"]');
  var brandListTop = brandsMenu.find('.mega-menu__linklist').offset().top;
  var brandLIs = brandsMenu.find('.mega-menu__linklist > li');
  var brandSubmenus = brandsMenu.find('.mega-menu__linklist > li > ul');

  brandLIs.on({
    mouseenter: function () {
      var thisLI = $(this);
      var topPos = thisLI.position().top;
      var setTop = topPos - 48;
      thisLI.children('ul').css('transform', 'translateY(-'+setTop+'px)');
      brandLIs.removeClass('selected')
      thisLI.addClass('selected');
    },
    mouseleave: function () {
    }
  });
  brandLIs.first().addClass('selected');
  
}

function handleMobileBrandsMenu() {
  const sidebarPanel = document.querySelector('#header-panel-2[data-title="Brands"]');
  if (!sidebarPanel) return;

  const linkButtons = sidebarPanel.querySelectorAll('.header-sidebar__linklist-button');
  const brandsTestItems = sidebarPanel.querySelectorAll('ul.brands-sub-links > li.brands-test');
  const listItems = sidebarPanel.querySelectorAll('ul.header-sidebar__linklist > li');

  linkButtons.forEach((button, index) => {
    button.style.cursor = 'pointer';

    button.addEventListener('click', e => {
      e.preventDefault();

      // Close all details except the clicked one
      linkButtons.forEach((btn, i) => {
        const details = btn.closest('details');
        if (details) {
          if (i === index) {
            details.open = true;
            btn.parentElement.setAttribute('aria-expanded', 'true');
          } else {
            details.open = false;
            btn.parentElement.setAttribute('aria-expanded', 'false');
          }
        }
      });

      brandsTestItems.forEach(el => el.classList.remove('is-visible'));

      if (brandsTestItems[index]) {
        brandsTestItems[index].classList.add('is-visible');
      }

      listItems.forEach(li => li.classList.remove('is-bold'));

      if (listItems[index]) {
        listItems[index].classList.add('is-bold');
      }
    });
  });
}

function initYotpoPDP() {
  const yotpoAppBlock = document.querySelector('[id*="yotpo_product_reviews"]');
  // only check on PDP
  if (yotpoAppBlock) {
    const interval = setInterval(() => {
      const star = document.querySelector('.star-clickable');
      const reviewsSection = document.querySelector('.yotpo-main-reviews-widget');
  
      if (star && reviewsSection) {
        clearInterval(interval); // Stop checking once both elements exist
  
        star.addEventListener('click', function (e) {
          e.preventDefault();
          reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }, 300);
    
    // don't wait forever
    setTimeout(function () {
        clearInterval(interval);  
    },6000);
  }
}

function refreshProductCard(productCardEl, href) {
  //window.console.log('refreshProductCard');
  
  function __replaceHelper(parentEl, incomingEl, selector) {
    var newEl = incomingEl.find(selector);
    var existingEl = parentEl.find(selector);
    if (existingEl.length & newEl.length) {
      existingEl.replaceWith(newEl);
    } else if (existingEl.length) {
      existingEl.remove();
    } else if (newEl.length) {
      parentEl.append(newEl);
    }
  }

  window.fetch(href)
    .then()
    .then((_) => _.text())
    .then((html) => {
  
      var productTile = $(productCardEl);
      var infoDiv = productTile.find('.product-card__info');
      var figureDiv = productTile.find('.product-card__figure');
      var newTileContent = $(html);

      // replace product title
      var newTitle =  newTileContent.find('.product-title');
      productTile.find('.product-title').replaceWith(newTitle);
      
      // replace price
      var newPrice =  newTileContent.find('price-list');
      productTile.find('price-list').replaceWith(newPrice);

      // replace promo-message
      __replaceHelper(infoDiv, newTileContent, '.promo-message');
      
      // replace badges
      __replaceHelper(infoDiv, newTileContent, 'badge-list');

      // make sure the badge list is last
      if (infoDiv.find('badge-list').length) {
        infoDiv.find('badge-list').appendTo(infoDiv);
      }      

      // replace quick shop
      __replaceHelper(figureDiv, newTileContent, '.product-card__quick-buy-form');
      __replaceHelper(figureDiv, newTileContent, '.product-card__quick-add-modal-trigger');
      __replaceHelper(figureDiv, newTileContent, '.quick-buy-modal');
      
      // replace wishlist
      __replaceHelper(productTile, newTileContent, '.plp-wishlist-buttons');
      
    })
    .then((_) => {
      // 
      // swym wishlist https://developers.getswym.com/docs/swym-powered-buttons
      if (typeof _swat != 'undefined') {
        var productCardId = productCardEl.id;
        var productCardElHandle = productCardEl.getAttribute('handle');
        var cselector = null;
        if (productCardId) {
          cselector = '#' + productCardId;
        } else if (productCardElHandle) {
          cselector = `product-card[handle="${productCardElHandle}"]`;
        }
        if (cselector) {
          _swat.initializeActionButtons(cselector, '[data-swaction]');
        }
      }
    });
}  

function addProductCardListener() {
  // productcard:swatch:change is a custom event added in theme.js > ProductCard > onSwatchChanged_fn
  document.addEventListener("productcard:swatch:change", (e) => {
    //window.console.log('productcard:swatch:change', e);
    const target = e.detail.target;
    const productCard = target.closest('product-card');
    var productUrl = target.getAttribute("data-product-url"); 
    if (productUrl) {
      productUrl = themeUtils.appendToQuerystring(productUrl, { view: 'single-card' });
      new Promise(() => {
        refreshProductCard(productCard, productUrl)
      }).catch((err) => {
        console.log(err)
      })
    }
  });
}

function addPLPListener() {
  var mainCollection = document.querySelector('.shopify-section--main-collection');
  if (mainCollection) {
    document.addEventListener("facet:update:end", async (event) => {
      //window.console.log('facet:update:end',event);

      if (typeof _swat != 'undefined') {
          var cselector = (event && event.target && event.target.id) ? ('#' + event.target.id) : null;
          if (cselector) {
            _swat.initializeActionButtons(cselector, '[data-swaction]');
          }
        }

    });
  }
}

function addPDPListener() {
  var mainProduct = document.querySelector('.shopify-section--main-product');
  if (mainProduct) {
    // is PDP
    document.addEventListener("linkedvariantpicker:swatch:change", (e) => {
      refreshPDPReviews(e.detail.productUrl);
    });
  }  
}

function refreshPDPReviews(productUrl) {
  var appSection = document.querySelector('.shopify-section--apps');
  if (productUrl && appSection) {
    var sectionId = appSection.id.replace("shopify-section-", "");
    const newUrl = new URL(productUrl, window.location);
    newUrl.searchParams.set("section_id", sectionId);

    window.fetch(newUrl)
      .then()
      .then((_) => _.text())
      .then((html) => {
        const tempDoc = new DOMParser().parseFromString(html, "text/html");
        const newContent = tempDoc.getElementById(appSection.id);
        appSection.replaceWith(newContent);
      })
      .then((_) => {
        if (typeof yotpoWidgetsContainer != 'undefined') {
          yotpoWidgetsContainer.initWidgets();
        }
        initYotpoPDP();
      });
  }
}

$(document).ready(function () {
  handleBrandsMenu();
});

function gottexDomLoaded() { 
  initYotpoPDP();
  addPDPListener();
  addProductCardListener();
  addPLPListener();

  document.querySelectorAll('.accordion__disclosure.group').forEach(group => {
    const labelSpan = group.querySelector('.accordion__toggle h6 span, .accordion__toggle span');
  
    if (labelSpan && labelSpan.textContent.trim() === 'Size') {
      group.classList.add('has-size');
    }
  });
}

if (/complete|interactive|loaded/.test(document.readyState)) {
    gottexDomLoaded();
} else {
    document.addEventListener('DOMContentLoaded', gottexDomLoaded);
}


/* PLP wishlist hearts follow selected swatch
   - Only the heart whose data-product-url matches the checked swatch is clickable
   - Others are disabled via pointer-events (no layout changes)
*/

/*(() => {
  // Prevent double-binding if this file is loaded twice
  if (window.__plpHeartsBound) return;
  window.__plpHeartsBound = true;

  const WRAP_SEL   = 'product-card'; // each product tile
  const SWATCH_SEL = 'fieldset.product-card__swatches-color input[type="radio"]';
  const HEART_SEL  = '.plp-wishlist-buttons [data-swaction="addToWishlist"]';
  const INACTIVE   = 'swym-heart--inactive';

  const normPath = (u) => {
    try {
      return new URL(u, window.location.origin).pathname.replace(/\/+$/,'');
    } catch {
      return '';
    }
  };

  const setActive = (btn, on) => {
    btn.style.pointerEvents = on ? 'auto' : 'none';
    btn.classList.toggle(INACTIVE, !on);
    btn.setAttribute('aria-disabled', String(!on));
    if (!on) btn.setAttribute('tabindex', '-1');
    else btn.removeAttribute('tabindex');
  };

  const syncOne = (wrap) => {
    if (!wrap) return;

    // Use the checked swatch; fallback to first swatch if none checked
    const checked = wrap.querySelector(`${SWATCH_SEL}:checked`) || wrap.querySelector(SWATCH_SEL);
    if (!checked) return;

    const selPath = normPath(checked.getAttribute('data-product-url') || '');
    const hearts  = wrap.querySelectorAll(HEART_SEL);
    if (!hearts.length) return;

    let matched = 0;
    hearts.forEach((b) => {
      const bPath = normPath(b.getAttribute('data-product-url') || '');
      const isActive = (bPath === selPath);
      setActive(b, isActive);
      if (isActive) matched++;
    });

    // If nothing matched (unexpected data), keep all clickable so UX isn’t blocked
    if (!matched) hearts.forEach((b) => setActive(b, true));
  };

  const syncAll = () => {
    document.querySelectorAll(WRAP_SEL).forEach(syncOne);
  };

  // Initial pass once DOM is ready
  const ready = () => {
    syncAll();

    // Re-sync a single card when its swatch changes (delegated listener)
    document.addEventListener('change', (e) => {
      if (!e.target.matches(SWATCH_SEL)) return;
      const wrap = e.target.closest(WRAP_SEL);
      if (wrap) syncOne(wrap);
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  // Optional: expose a manual hook for re-rendered grids (e.g., infinite scroll)
  window.syncPlpHearts = syncAll;
})();
*/

/* Sync wishlist hearts to the selected swatch (works in carousels & lazy-loaded cards) */
/* Sync wishlist hearts to the selected swatch (works in carousels & lazy-loaded cards) */
/*(() => {
  const SEL = {
    card: 'product-card',
    swatchInput: 'fieldset.product-card__swatches-color input[type="radio"]',
    heartBtn: '.plp-wishlist-buttons .swym-icontext'
  };

  // Extract /products/<handle> from any URL, ignoring origin & query
  const handleFromUrl = (url) => {
    try {
      const u = new URL(url, location.origin);
      const m = u.pathname.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    } catch {
      return null;
    }
  };

  // For a swatch input, pick the target handle:
  // Prefer its own data-product-url; otherwise use the enclosing card's "handle" attribute.
  const targetHandleForInput = (input) => {
    if (input?.dataset?.productUrl) return handleFromUrl(input.dataset.productUrl);
    const card = input?.closest(SEL.card);
    return card?.getAttribute('handle') || null;
  };

  const syncHeartsForCard = (card) => {
    if (!card) return;
    const checked = card.querySelector(`${SEL.swatchInput}:checked`);
    const targetHandle = checked ? targetHandleForInput(checked) : card.getAttribute('handle');

    const hearts = card.querySelectorAll(SEL.heartBtn);
    hearts.forEach(btn => {
      const btnHandle = handleFromUrl(btn.dataset.productUrl || '');
      const isMatch = !!targetHandle && !!btnHandle && btnHandle === targetHandle;

      // Always clear platform-added disabled artifacts on the ACTIVE heart
      if (isMatch) {
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
        btn.removeAttribute('tabindex');
        btn.setAttribute('aria-hidden', 'false');
      } else {
        // Suppress non-active hearts without layout changes
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.35';
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-hidden', 'true');
      }

      // Keep your class toggle for styling hooks
      btn.classList.toggle('is-active', isMatch);
    });
  };

  const initCard = (card) => syncHeartsForCard(card);

  // Initial pass
  document.querySelectorAll(SEL.card).forEach(initCard);

  // Delegated handler for radios (covers carousels & dynamically-added content)
  document.addEventListener('change', (e) => {
    const input = e.target.closest(SEL.swatchInput);
    if (!input) return;
    const card = input.closest(SEL.card);
    if (card) syncHeartsForCard(card);
  });

  // Observe DOM mutations for newly inserted product cards (e.g., carousel slides)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(SEL.card)) initCard(node);
        node.querySelectorAll?.(SEL.card).forEach(initCard);
      });
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();


(() => {
  const SELECTOR = '.product-info__block-item[data-block-id="description"] details.accordion__disclosure';
  const KEY = 'acc_desc_userClosed:' + location.pathname; // remember per product page

  const wasClosedByUser = () => sessionStorage.getItem(KEY) === 'closed';
  const setClosedByUser = (closed) => closed ? sessionStorage.setItem(KEY, 'closed')
                                             : sessionStorage.removeItem(KEY);

  function wireCloseMemory(details) {
    if (!details || details.__wired) return;
    details.__wired = true;

    // If user clicks the summary to toggle, remember their choice
    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', () => {
        // After the toggle settles, check state
        setTimeout(() => setClosedByUser(!details.open), 0);
      });
    }

    // If something else toggles it, remember too
    details.addEventListener('toggle', () => setClosedByUser(!details.open));
  }

  function ensureOpenIfAllowed() {
    const details = document.querySelector(SELECTOR);
    if (!details) return;

    wireCloseMemory(details);

    // Keep it open across swatch-driven re-renders unless user closed it
    if (!wasClosedByUser() && !details.open) {
      details.open = true;
      details.setAttribute('aria-expanded', 'true');
    }
  }

  // Run now (handles current page state)
  ensureOpenIfAllowed();

  // Observe for DOM replacements when swatches change
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      ensureOpenIfAllowed();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

/** dynamic pdp product badges **/

document.addEventListener('DOMContentLoaded', function () {
    function syncSoldOutBadge() {
      const sizeFieldset = document.querySelector('.variant-picker__option.option-size');
      const soldOutBadge = document.querySelector('sold-out-badge[data-sold-out-badge]');

      if (!sizeFieldset || !soldOutBadge) return;

      const checked = sizeFieldset.querySelector('input[type="radio"]:checked');
      if (!checked) {
        soldOutBadge.setAttribute('hidden', '');
        return;
      }

      const label = sizeFieldset.querySelector(`label[for="${checked.id}"]`);
      if (!label) {
        soldOutBadge.setAttribute('hidden', '');
        return;
      }

      const isSoldOut = label.dataset.available === 'false';

      // Toggle the `hidden` attribute instead of a class
      if (isSoldOut) {
        soldOutBadge.removeAttribute('hidden');
      } else {
        soldOutBadge.setAttribute('hidden', '');
      }
    }

    // Run once on page load
    syncSoldOutBadge();

    // Update on any size change
    document.addEventListener('change', function (event) {
      if (event.target.matches('.variant-picker__option.option-size input[type="radio"]')) {
        syncSoldOutBadge();
      }
    });

    // Handle Shopify dynamic section reloads
    document.addEventListener('shopify:section:load', syncSoldOutBadge);

    // Handle Safari page cache restore
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) syncSoldOutBadge();
    });
  });

/** quickview wishlist button **/

function updateWishlistOnSwatchChange() {
  const STORAGE_KEY = 'customWishlistedProductIds';
  const productCache = {};

  function loadWishlistedIds() {
    try {
      return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY)) || []);
    } catch {
      return new Set();
    }
  }

  function saveWishlistedIds(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  }

  const wishlistedIds = loadWishlistedIds();

  function isWishlistedButton(button) {
    return (
      button.classList.contains('wg-heart-icon-solid') ||
      button.classList.contains('selected')
    );
  }

  function makeSolid(button) {
    button.classList.remove('wg-heart-icon-blank');
    button.classList.add('wg-heart-icon-solid', 'selected');
    button.style.filter =
      'brightness(0) saturate(100%) invert(58%) sepia(39%) saturate(424%) hue-rotate(3deg) brightness(96%) contrast(95%)';
  }

  function makeBlank(button) {
    button.classList.remove('wg-heart-icon-solid', 'selected');
    button.classList.add('wg-heart-icon-blank');
    button.style.filter = '';
  }

  function captureVisibleWishlistStates() {
    document.querySelectorAll('.wf-wishlist-collection-icon').forEach((wishlist) => {
      const button = wishlist.querySelector('.wg-collectionIcon');
      const productId = wishlist.getAttribute('product-id');

      if (!button || !productId) return;

      if (isWishlistedButton(button)) {
        wishlistedIds.add(String(productId));
      }
    });

    saveWishlistedIds(wishlistedIds);
  }

  async function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];

    const product = await fetch(`/products/${handle}.js`).then((res) => res.json());
    productCache[handle] = product;

    return product;
  }

  captureVisibleWishlistStates();

  document.addEventListener('change', async (event) => {
    const swatch = event.target.closest('.product-card__swatches-color input[type="radio"]');
    if (!swatch) return;

    const card = swatch.closest('product-card');
    const wishlist = card?.querySelector('.wf-wishlist-collection-icon');
    const button = wishlist?.querySelector('.wg-collectionIcon');

    const handle = swatch.dataset.productUrl
      ?.split('/products/')[1]
      ?.split('?')[0];

    if (!wishlist || !button || !handle) return;

    // Save the outgoing product state before changing the wishlist attributes
    const previousProductId = wishlist.getAttribute('product-id');
    if (previousProductId && isWishlistedButton(button)) {
      wishlistedIds.add(String(previousProductId));
      saveWishlistedIds(wishlistedIds);
    }

    const product = await getProduct(handle);
    const productId = String(product.id);

    wishlist.setAttribute('product-id', productId);
    wishlist.setAttribute('product-handle', handle);

    button.setAttribute(
      'onclick',
      `collectionIconClick(event,'${productId}','${handle}')`
    );

    if (wishlistedIds.has(productId)) {
      makeSolid(button);
    } else {
      makeBlank(button);
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.wg-collectionIcon');
    if (!button) return;

    const wishlist = button.closest('.wf-wishlist-collection-icon');
    const productId = wishlist?.getAttribute('product-id');

    if (!productId) return;

    setTimeout(() => {
      if (isWishlistedButton(button)) {
        wishlistedIds.add(String(productId));
      } else {
        wishlistedIds.delete(String(productId));
      }

      saveWishlistedIds(wishlistedIds);
    }, 1000);
  });
}

updateWishlistOnSwatchChange();

/** Updated Quickview slide animation **/
document.addEventListener('click', function (event) {
  const closeButton = event.target.closest('.quick-buy-modal__close-button');
  if (!closeButton) return;

  const modal = closeButton.closest('.quick-buy-modal');
  if (!modal) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  modal.classList.add('is-closing');

  setTimeout(() => {
    modal.classList.remove('is-closing');
    modal.removeAttribute('open');
    modal.style.display = 'none';
  }, 300);
}, true);


/** cart drawer discount code **/

(function () {
  if (window.__cartDrawerDiscountBound) return;
  window.__cartDrawerDiscountBound = true;

  let submitting = false;

  let currentMessage = {
    text: '',
    type: ''
  };

  const root = window.Shopify?.routes?.root || '/';


  /* ---------------------------------------------
   * MESSAGE STYLES
   * --------------------------------------------- */

  const style = document.createElement('style');

  style.textContent = `
    #CartDrawer-DiscountError {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }

    #CartDrawer-CustomDiscountMessage {
      display: none;
      margin-top: 8px;
      font-size: 13px;
      line-height: 1.4;
    }

    #CartDrawer-CustomDiscountMessage[data-type="error"] {
      display: block;
      color: red;
    }

    #CartDrawer-CustomDiscountMessage[data-type="success"] {
      display: block;
      color: green;
    }
  `;

  document.head.appendChild(style);


  /* ---------------------------------------------
   * ELEMENT HELPERS
   * --------------------------------------------- */

  function getForm() {
    return document.getElementById(
      'CartDrawer-DiscountForm'
    );
  }

  function getInput() {
    return document.getElementById(
      'CartDrawer-DiscountCode'
    );
  }

  function getSubmitButton() {
    return document.getElementById(
      'CartDrawer-DiscountButton'
    );
  }

  function getSubmitButtonText() {
    return (
      getSubmitButton()
        ?.querySelector('.btn-text') ||
      null
    );
  }

  function getSubmitButtonLoading() {
    return (
      getSubmitButton()
        ?.querySelector('.btn-loading') ||
      null
    );
  }


  /* ---------------------------------------------
   * CUSTOM MESSAGE
   * --------------------------------------------- */

  function getCustomMessage() {
    let message =
      document.getElementById(
        'CartDrawer-CustomDiscountMessage'
      );

    if (message) {
      return message;
    }

    const errorElement =
      document.getElementById(
        'CartDrawer-DiscountError'
      );

    if (!errorElement) {
      return null;
    }

    message =
      document.createElement('p');

    message.id =
      'CartDrawer-CustomDiscountMessage';

    message.setAttribute(
      'role',
      'status'
    );

    message.setAttribute(
      'aria-live',
      'polite'
    );

    /*
     * Place custom message directly underneath
     * the existing CartDrawer-DiscountError.
     */
    errorElement.insertAdjacentElement(
      'afterend',
      message
    );

    return message;
  }


  function renderCurrentMessage() {
    if (!currentMessage.text) {
      return;
    }

    const message =
      getCustomMessage();

    if (!message) {
      return;
    }

    message.textContent =
      currentMessage.text;

    message.dataset.type =
      currentMessage.type;

    message.style.display =
      'block';
  }


  function setMessage(
    text,
    type = 'error'
  ) {
    currentMessage = {
      text,
      type
    };

    const message =
      getCustomMessage();

    if (!message) {
      return;
    }

    message.textContent =
      text;

    message.dataset.type =
      type;

    message.style.display =
      text
        ? 'block'
        : 'none';
  }


  function hideMessage() {
    currentMessage = {
      text: '',
      type: ''
    };

    const message =
      document.getElementById(
        'CartDrawer-CustomDiscountMessage'
      );

    if (!message) {
      return;
    }

    message.textContent = '';

    message.removeAttribute(
      'data-type'
    );

    message.style.display =
      'none';
  }


  /*
   * Cart drawer HTML can be replaced after
   * discount/cart updates.
   *
   * Recreate our message in the new drawer.
   */
  const messageObserver =
    new MutationObserver(() => {
      if (!currentMessage.text) {
        return;
      }

      if (
        document.getElementById(
          'CartDrawer-CustomDiscountMessage'
        )
      ) {
        return;
      }

      requestAnimationFrame(() => {
        if (!currentMessage.text) {
          return;
        }

        if (
          !document.getElementById(
            'CartDrawer-CustomDiscountMessage'
          )
        ) {
          renderCurrentMessage();
        }
      });
    });

  messageObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* ---------------------------------------------
   * LOADING STATE
   * --------------------------------------------- */

  function setLoading(isLoading) {
    const button =
      getSubmitButton();

    const text =
      getSubmitButtonText();

    const loading =
      getSubmitButtonLoading();

    if (!button) {
      return;
    }

    button.disabled =
      isLoading;

    button.setAttribute(
      'aria-busy',
      isLoading
        ? 'true'
        : 'false'
    );

    if (text) {
      text.style.display =
        isLoading
          ? 'none'
          : 'inline';
    }

    if (loading) {
      loading.style.display =
        isLoading
          ? 'block'
          : 'none';
    }
  }


  /* ---------------------------------------------
   * DISCOUNT HELPERS
   * --------------------------------------------- */

  function normalizeCode(code) {
    return String(code || '')
      .trim()
      .toLowerCase();
  }


  function uniqueCodes(codes) {
    const seen = new Set();

    return codes.filter(code => {
      const normalized =
        normalizeCode(code);

      if (
        !normalized ||
        seen.has(normalized)
      ) {
        return false;
      }

      seen.add(normalized);

      return true;
    });
  }


  /*
   * Return all discount applications that
   * actually represent discount codes.
   */
  function getDiscountCodeApplications(
    cart
  ) {
    const applications = [
      ...(cart?.cart_level_discount_applications || []),
      ...(cart?.discount_applications || [])
    ];

    return applications.filter(
      discount => {
        return (
          discount?.type ===
            'discount_code' &&
          (
            discount?.title ||
            discount?.code
          )
        );
      }
    );
  }


  /*
   * IMPORTANT:
   *
   * A code appearing inside cart.discount_codes
   * does NOT automatically mean it worked.
   *
   * It can exist with:
   *
   * applicable: false
   *
   * Only treat it as active when:
   *
   * 1. applicable === true
   *
   * OR
   *
   * 2. it appears as an actual discount_code
   *    application.
   */
  function discountCodeIsApplied(
    cart,
    code
  ) {
    const normalized =
      normalizeCode(code);

    if (!normalized) {
      return false;
    }


    /*
     * First inspect discount_codes because
     * it may explicitly tell us applicable.
     */
    if (
      Array.isArray(
        cart?.discount_codes
      )
    ) {
      const match =
        cart.discount_codes.find(
          discount => {
            const discountCode =
              discount?.code ||
              discount?.title;

            return (
              normalizeCode(
                discountCode
              ) === normalized
            );
          }
        );

      if (match) {
        /*
         * Explicit false = definitely invalid /
         * not applicable.
         */
        if (
          match.applicable === false
        ) {
          return false;
        }

        /*
         * Explicit true = successfully applicable.
         */
        if (
          match.applicable === true
        ) {
          return true;
        }

        /*
         * If Shopify doesn't provide an
         * applicable value, don't assume true.
         * Continue to discount applications.
         */
      }
    }


    /*
     * Look for an actual applied discount
     * application.
     */
    return getDiscountCodeApplications(
      cart
    ).some(discount => {
      const discountCode =
        discount?.code ||
        discount?.title;

      return (
        normalizeCode(
          discountCode
        ) === normalized
      );
    });
  }


  /*
   * Collect ONLY codes that are actually active.
   *
   * Invalid / non-applicable codes are deliberately
   * excluded so they never get preserved during
   * rollback.
   */
  function getAppliedDiscountCodes(
    cart
  ) {
    const possibleCodes = [];


    /*
     * Explicit discount_codes.
     */
    if (
      Array.isArray(
        cart?.discount_codes
      )
    ) {
      cart.discount_codes.forEach(
        discount => {
          const code =
            discount?.code ||
            discount?.title;

          if (code) {
            possibleCodes.push(
              String(code).trim()
            );
          }
        }
      );
    }


    /*
     * Applied discount applications.
     */
    getDiscountCodeApplications(
      cart
    ).forEach(discount => {
      const code =
        discount?.code ||
        discount?.title;

      if (code) {
        possibleCodes.push(
          String(code).trim()
        );
      }
    });


    /*
     * Deduplicate and then verify each code
     * is actually applied.
     */
    return uniqueCodes(
      possibleCodes
    ).filter(code => {
      return discountCodeIsApplied(
        cart,
        code
      );
    });
  }


  /* ---------------------------------------------
   * SHOPIFY API
   * --------------------------------------------- */

  async function fetchCart() {
    const response =
      await fetch(
        `${root}cart.js`,
        {
          method: 'GET',

          headers: {
            Accept:
              'application/json'
          },

          cache:
            'no-store'
        }
      );

    if (!response.ok) {
      throw new Error(
        `Cart fetch failed: ${response.status}`
      );
    }

    return response.json();
  }


  async function updateDiscounts(
    codes
  ) {
    const discountValue =
      codes.join(',');

    const response =
      await fetch(
        `${root}cart/update.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            discount:
              discountValue
          })
        }
      );

    if (!response.ok) {
      throw new Error(
        `Discount update failed: ${response.status}`
      );
    }

    return response.json();
  }


  /* ---------------------------------------------
   * THEME REFRESH
   * --------------------------------------------- */

  function refreshCartDrawerViaTheme(
    cart
  ) {
    document.documentElement
      .dispatchEvent(
        new CustomEvent(
          'cart:change',
          {
            bubbles: true,

            detail: {
              baseEvent:
                'discount:apply',

              cart
            }
          }
        )
      );

    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true,

          detail: {
            cart
          }
        }
      )
    );
  }


  /* ---------------------------------------------
   * APPLY DISCOUNT CODE
   * --------------------------------------------- */

  async function applyDiscountCode(
    newCode
  ) {
    /*
     * Fetch the confirmed cart BEFORE
     * attempting the new code.
     */
    const beforeCart =
      await fetchCart();


    /*
     * Only actual working codes are captured.
     */
    const previousCodes =
      getAppliedDiscountCodes(
        beforeCart
      );


    /*
     * Only show "already applied" if the code
     * is genuinely active BEFORE this attempt.
     */
    if (
      discountCodeIsApplied(
        beforeCart,
        newCode
      )
    ) {
      return {
        success: true,
        cart: beforeCart,
        alreadyApplied: true
      };
    }


    /*
     * Preserve all existing valid codes while
     * attempting the new candidate.
     */
    const requestedCodes =
      uniqueCodes([
        ...previousCodes,
        newCode
      ]);


    /*
     * Attempt candidate.
     */
    const attemptedCart =
      await updateDiscounts(
        requestedCodes
      );


    /*
     * IMPORTANT:
     *
     * Do not simply check whether newCode
     * exists in discount_codes.
     *
     * Verify that Shopify actually considers
     * the candidate applied.
     */
    const candidateApplied =
      discountCodeIsApplied(
        attemptedCart,
        newCode
      );


    /*
     * Candidate worked.
     */
    if (candidateApplied) {
      return {
        success: true,
        cart: attemptedCart,
        alreadyApplied: false
      };
    }


    /*
     * -----------------------------------------
     * INVALID / NOT APPLICABLE
     * -----------------------------------------
     *
     * Restore the exact previous valid code set.
     *
     * This guarantees that trying a bad code
     * cannot destroy an existing good code.
     */
    if (previousCodes.length) {
      await updateDiscounts(
        previousCodes
      );
    } else {
      await updateDiscounts([]);
    }


    /*
     * Confirm final restored state.
     */
    const finalCart =
      await fetchCart();


    return {
      success: false,
      cart: finalCart,
      previousCodes
    };
  }


  /* ---------------------------------------------
   * REMOVE ALL CODES
   * --------------------------------------------- */

  async function removeDiscountCodes() {
    const cart =
      await updateDiscounts([]);

    return {
      success: true,
      cart
    };
  }


  /* ---------------------------------------------
   * SUBMIT HANDLER
   * --------------------------------------------- */

  document.addEventListener(
    'submit',

    async function (e) {
      const form =
        e.target;

      if (
        !form ||
        form.id !==
          'CartDrawer-DiscountForm'
      ) {
        return;
      }


      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();


      if (submitting) {
        return;
      }


      const input =
        getInput();

      if (!input) {
        return;
      }


      const code =
        input.value.trim();


      submitting = true;

      hideMessage();

      setLoading(true);


      try {

        /* ---------------------------------
         * REMOVE
         * --------------------------------- */

        if (!code) {
          const result =
            await removeDiscountCodes();


          setMessage(
            'Promo code removed.',
            'success'
          );


          refreshCartDrawerViaTheme(
            result.cart
          );


          return;
        }


        /* ---------------------------------
         * APPLY
         * --------------------------------- */

        const result =
          await applyDiscountCode(
            code
          );


        /* ---------------------------------
         * VALID / ALREADY APPLIED
         * --------------------------------- */

        if (result.success) {

          setMessage(
            result.alreadyApplied
              ? 'Promo code is already applied.'
              : 'Promo code applied.',
            'success'
          );


          refreshCartDrawerViaTheme(
            result.cart
          );


          return;
        }


        /* ---------------------------------
         * INVALID / NOT APPLICABLE
         * ---------------------------------
         *
         * Previous valid codes have already
         * been restored.
         *
         * Set the error BEFORE refreshing
         * the drawer so it survives the DOM
         * replacement.
         */

        setMessage(
          'Code is invalid or not applicable to this cart.',
          'error'
        );


        refreshCartDrawerViaTheme(
          result.cart
        );


        return;

      } catch (error) {

        console.error(
          'Discount error:',
          error
        );


        setMessage(
          code
            ? 'Could not apply this code.'
            : 'Could not remove this code.',
          'error'
        );

      } finally {

        submitting = false;

        setLoading(false);
      }
    },

    true
  );


  /* ---------------------------------------------
   * APPLY BUTTON
   * --------------------------------------------- */

  document.addEventListener(
    'click',

    function (e) {
      const button =
        e.target.closest(
          '#CartDrawer-DiscountButton'
        );


      if (!button) {
        return;
      }


      const form =
        getForm();


      if (!form) {
        return;
      }


      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();


      if (submitting) {
        return;
      }


      if (
        typeof form.requestSubmit ===
        'function'
      ) {

        form.requestSubmit();

      } else {

        form.dispatchEvent(
          new Event(
            'submit',
            {
              bubbles: true,
              cancelable: true
            }
          )
        );
      }
    },

    true
  );

})();

/** rebuy **/

(function () {

  function refreshCart() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    console.log("cart refresh dispatched");
  }

  function openCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    const isOpen =
      drawer.hasAttribute("open") ||
      drawer.getAttribute("aria-hidden") === "false";

    if (!isOpen && typeof drawer.show === "function") {
      drawer.show();
    }
  }

  function afterRebuyAdd() {
    setTimeout(() => {
      refreshCart();
      openCartDrawer();
    }, 1500);
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest("button.rebuy-button, .rebuy-button");
      if (!btn) return;

      afterRebuyAdd();
    },
    true
  );
})();

